// link
import { NavLink } from "react-router-dom";

const MobileNav = (props: object | any) => {
    return (
        <>
            <section className="d-md-none d-inline-block mobile-menu d-flex justify-content-center position-relative">
                <div
                    className="header-mobile fixed-bottom py-2 d-md-none d-inline-block position-fixed shadow shadow-lg">
                    <div className="px-4">
                        <div className="d-flex align-items-center justify-content-between">
                            {props.routes.map((link: object | any, index: number) => (
                                <>
                                    {link.child ? (
                                        <>
                                            <div key={link.address} className={link.mobileShow ? 'btn-phone d-flex justify-content-center p-0 mx-1 text-blue' : 'd-none'}>
                                                <div
                                                    data-bs-toggle={link.toggle} data-bs-target={link.mobaddress}>
                                                    <div className="activator d-flex justify-content-center align-items-center">
                                                        <button className="btn btn-outline-site p-0">
                                                            {link.icon}
                                                        </button>
                                                    </div>
                                                    <p className="text-center mb-0 mt-3">
                                                        {link.label}
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div key={link.address} className={link.mobileShow ? 'btn-phone d-flex justify-content-center p-0 mx-1 text-blue' : 'd-none'}>
                                                <NavLink className={'text-decoration-none'}
                                                    to={link.address}>
                                                    <div className="activator d-flex justify-content-center align-items-center">
                                                        <button className="btn btn-outline-site p-0">
                                                            {link.icon}
                                                        </button>
                                                    </div>
                                                    <p className="text-center mb-0 mt-3">
                                                        {link.label}
                                                    </p>
                                                </NavLink>
                                            </div>
                                        </>
                                    )}
                                </>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MobileNav;